var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSaltdalshytta = function SvgSaltdalshytta(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 36 19",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h35.8889v19h-35.8889z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.8612 7.25678c0 2.90332-2.3535 5.25682-5.2568 5.25682s-5.2567-2.3535-5.2567-5.25682c0-2.90329 2.3534-5.25678 5.2567-5.25678s5.2568 2.35349 5.2568 5.25678z",
    fill: "#fe7060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 16.8632c-3.7365-1.7762-5.2671-4.9754-6.1055-5.9743l-.0573.0634c-12.6079 13.0016-14.4289-3.22404-25.8372 3.3745l.9022 2.8122c9.3073-5.8211 12.8141 7.4426 24.1705-3.9028 1.6418 1.5806 3.8156 3.5869 6.7527 4.3626z",
    fill: "#263056"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSaltdalshytta);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "saltdalshytta.51c25bf9d04fe9110fc9ab0a664a133b.svg";